<template>
  <div class="popup-main">
    <el-dialog
      :title="detailId ? '编辑设备' : '新增设备'"
      width="800px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <!-- 设备分类 -->
        <div v-if="loaded" class="mu-ban-category">
          <div class="t-a-r" style="width: 240px">
            <span class="m-r-5 c-black">设备分类</span>
          </div>
          <b-goods-texture
            :data.sync="categoryTextureData"
            :bao_han="['加工']"
            :categoryTextureStr="categoryTextureStr"
            width="1288px"
          />
        </div>
        <e-form ref="refForm" :config="formConfig" :column="formColumn" :data.sync="selfData" />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗-绑定模板 -->
    <PopupBindMuBan
      v-if="isShowPopupBindMuBan"
      :show.sync="isShowPopupBindMuBan"
      :list="selfData.she_bei_mu_ban_list"
      @success="bindMuBanSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupBindMuBan: () => import('./popup-bind-mu-ban')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      timer: null,
      selfShow: false,
      selfData: {
        id: '',
        banzu_ids: [],
        banzu_names: [],
        lei_mu_name: '',
        lei_mu_data: {},
        name: '',
        type: '',
        remark: '',
        img_list: [],
        she_bei_mu_ban_list: []
      },
      categoryTextureStr: '',
      categoryTextureData: {},
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'text',
          title: '设备名称',
          field: 'name'
        },
        {
          type: 'text',
          title: '设备号',
          field: 'type'
        },
        {
          type: 'upload_image',
          title: '设备照片',
          field: 'img_list',
          size: '28px',
          isDelete: true
        },
        {
          type: 'select',
          title: '班组',
          field: 'banzu_ids',
          multiple: true,
          collapseTags: true,
          options: [],
          fnChange: () => {
            this.banzuChange()
          }
        },
        {
          type: 'button',
          title: '可加工商品',
          placeholder: '绑定',
          icon: 'vxe-icon-link',
          isError: true,
          fnChange: () => {
            this.isShowPopupBindMuBan = true
          }
        },
        {
          type: 'text',
          title: '设备负责人',
          field: 'she_bei_fu_ze_ren'
        },
        {
          type: 'text',
          title: '设备说明',
          field: 'remark'
        },
        {
          type: 'text',
          title: '设备价格',
          field: 'she_bei_price',
          suffix: '元'
        },
        {
          type: 'text',
          title: '设备每小时产值',
          field: 'she_bei_every_hour_value',
          suffix: '件'
        },
        {
          type: 'text',
          title: '设备每月产值',
          field: 'she_bei_every_month_value',
          suffix: '件'
        },
        {
          type: 'text',
          title: '设备占地使用',
          field: 'she_bei_zhan_di',
          suffix: 'm²'
        }
      ],
      isShowPopupBindMuBan: false
    }
  },
  computed: {
    // 类目选中字符串
    categoryActiveStr() {
      let result = ''
      let listName = []
      if (this.categoryTextureData.category_list) {
        listName = this.categoryTextureData.category_list.map((item) => {
          return item.name
        }) // 类目
        if (this.categoryTextureData.texture_data.key) {
          listName.push(this.categoryTextureData.texture_data.key) // 材质
        }
      }
      result = listName.join('/')
      return result // 类目材质拼接成字符串
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    selfData: {
      handler(val) {
        this.formColumn.forEach((item) => {
          if (item.title.includes('可加工商品')) {
            let len = val.she_bei_mu_ban_list.length
            item.isError = !len
            item.placeholder = `绑定(${len})`
          }
        })
      },
      deep: true,
      immediate: true
    },
    // 类目材质数据
    categoryTextureData: {
      handler(val) {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (val.category_list && val.category_list.length) {
            this.selfData.lei_mu_name = this.categoryActiveStr
            this.selfData.lei_mu_data = this.$util.deepCopy(val)
          }
          this.timer = null
        }, 500)
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    this.selfShow = this.show
    // 加载班组下拉列表
    await this.getBanzuList()
    if (this.detailId) {
      this.getDetailData()
    } else {
      this.initSelfData()
    }
  },
  methods: {
    // 获取班组列表
    getBanzuList() {
      return this.$api({
        method: 'post',
        url: '/admin/gcvip/banzu/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let result = res.data.page.list.map((item) => {
              return {
                key: item.name,
                val: item.id,
                disabled: item.status === false
              }
            })
            // 将班组选项写入 formColumn 对应字段的 options
            this.formColumn.forEach((item) => {
              if (item.field === 'banzu_ids') item.options = result
            })
          }
        })
        .catch(() => {})
    },
    // 班组选择变化-回填班组名称（多选）
    banzuChange() {
      let banzu_ids = this.selfData.banzu_ids || []
      this.formColumn.forEach((item) => {
        if (item.field === 'banzu_ids') {
          this.selfData.banzu_names = item.options
            .filter((opt) => banzu_ids.includes(opt.val))
            .map((opt) => opt.key)
        }
      })
    },
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/sheBei/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          // 合并字段，保留默认结构，避免缺失班组等新字段
          this.selfData = {
            ...this.selfData,
            ...result
          }
          this.categoryTextureStr = result.lei_mu_name
          // 保证 banzu_ids / banzu_names 为数组结构
          if (!Array.isArray(this.selfData.banzu_ids)) {
            this.selfData.banzu_ids = []
          }
          if (!Array.isArray(this.selfData.banzu_names)) {
            this.selfData.banzu_names = []
          }
          // 编辑时若有 banzu_ids 但 banzu_names 为空，根据选项回填班组名称（多选）
          if (this.selfData.banzu_ids.length && !this.selfData.banzu_names.length) {
            this.formColumn.forEach((item) => {
              if (item.field === 'banzu_ids') {
                this.selfData.banzu_names = item.options
                  .filter((opt) => this.selfData.banzu_ids.includes(opt.val))
                  .map((opt) => opt.key)
              }
            })
          }
        }
      })
      this.loaded = true
    },
    // 初始化数据
    initSelfData() {
      this.loaded = false
      this.categoryTextureStr = ''
      this.selfData.lei_mu_name = this.categoryActiveStr
      this.loaded = true
    },
    // 绑定模板-成功
    bindMuBanSuccess(data) {
      this.selfData.she_bei_mu_ban_list = data
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/sheBei/saveOrUpdate',
            data: this.selfData
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .mu-ban-category {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
